// extracted by mini-css-extract-plugin
export default {"input":"LeaveTypeFilter_input__m0jPt"};